module.exports = __webpack_public_path__ + "img/fitas-senhor-do-bonfim.147c67f3.jpg";